var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLoginUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "61px",
    viewBox: "0 0 60 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31DAC627-6EE6-4FEF-B39B-2033D149FC3F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uC751\\uC6A9-\\uAD00\\uB9AC-:-\\uACC4\\uC815-\\uAD00\\uB9AC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "(A.3.1.2.3)-\\uC751\\uC6A9-\\uAD00\\uB9AC_\\uACC4\\uC815-\\uAD00\\uB9AC_\\uC870\\uD68C-[\\uB8E8\\uD2B8-\\uC0AC\\uC6A9\\uC790->-\\uB8E8\\uD2B8-\\uC0AC\\uC6A9\\uC790]-:-\\uBA54\\uC77C-\\uAC80\\uC99D-\\uC804",
    transform: "translate(-967.000000, -300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2605-Contents-Area",
    transform: "translate(320.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contents_\\uC870\\uD68C",
    transform: "translate(0.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(592.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico/login/user",
    transform: "translate(35.000000, 0.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 10.009676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.857143, 17.159444)",
    stroke: "#B6BFCE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75906974,13.7275555 C12.7990024,13.7275555 15.4907121,15.4147274 17.1428734,18.0067456 C16.0641327,19.6990933 15.4285714,21.7771661 15.4285714,24.0232221 L15.4285714,24.0232221 L0,24.0232221 C0,18.3370824 4.07334608,13.7275555 9.09807312,13.7275555 L9.75906974,13.7275555 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42876131,0 C12.2644057,0 14.5714286,2.30925511 14.5714286,5.14764324 C14.5714286,7.98641149 12.2644057,10.2952865 9.42876131,10.2952865 C6.59273715,10.2952865 4.28571429,7.98641149 4.28571429,5.14764324 C4.28571429,2.30925511 6.59273715,0 9.42876131,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1876412,13.7275555 C30.2123682,13.7275555 34.2857143,18.3370824 34.2857143,24.0232221 L15.4285714,24.0232221 C15.4285714,18.3370824 19.5019175,13.7275555 24.5266445,13.7275555 L25.1876412,13.7275555 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8573327,0 C27.6929771,0 30,2.30925511 30,5.14764324 C30,7.98641149 27.6929771,10.2952865 24.8573327,10.2952865 C22.0213086,10.2952865 19.7142857,7.98641149 19.7142857,5.14764324 C19.7142857,2.30925511 22.0213086,0 24.8573327,0 Z",
    id: "Path"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLoginUser);
export default __webpack_public_path__ + "static/media/ico-login-user.233eaecdd902ce972cb8a203233df176.svg";
export { ForwardRef as ReactComponent };